import React from 'react';
import cn from 'classnames';
import styles from './LoadingSpinner.module.scss';

export interface LoadingSpinnerProps {
  classNames?: string | string[];
  colour: string;
}

export const LoadingSpinner = ({ classNames, colour }: LoadingSpinnerProps) => {
  const cssClasses = cn(styles.spinnerRoot, classNames);
  const cssVars = {
    '--spinner-colour': colour,
  } as React.CSSProperties;
  return (
    <div style={cssVars}>
      <div className={cssClasses} data-testid="spinner-element" />
    </div>
  );
};

export default LoadingSpinner;
